/* eslint-disable import/prefer-default-export */
const CREDIT_CARD_KEY = 'pm4bcc2653a34f5454';

export const shouldEnableAddCreditCardInfo = (cards, paymentMethodKey) =>
  paymentMethodKey === CREDIT_CARD_KEY && cards && !cards.AccountHasCards;
